export const LMSRoutes = [
    {
        "url": "/lms",
        "loginRequired": true,
        "name": "lms",
        "type": "frontend",
        templateUrl: "../hmodules/lms/controllers/lms-main/lms-main.html",
        controller: "LMSMainController",
        controllerAs: "$ctrl",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS"
            }
        ],
        "abstract": true,
        "onEnter": ['userServices', '$state', '$filter', 'hUser', '$timeout', 'brandServices', function (userServices, $state, $filter, hUser, $timeout, brandServices) {
                // onEnter for children routes will wait until parent route return the promise
                // for more info https://ui-router.github.io/guide/transitionhooks#promises
                return new Promise(async (resolve, reject) => {
                    let serviceEnabled = false;
                    if (hUser.isEmployer()) {
                        let brandId = hUser.getUserContext().brand_id;
                        serviceEnabled = await brandServices.check(brandServices.SERVICES.LMS, brandId);
                    }
                    if (!serviceEnabled) {
                        Utils.hAlert({
                            title: $filter('translate')("Something Went Wrong"),
                            text: $filter('translate')("You don't have sufficient permissions to access Harri LMS. Please contact us for more details."),
                            custom_class: 'rejection-templates-error-alert',
                            button: {
                                text: $filter('translate')("Okay")
                            }
                        });
                        Utils.redirectToWorkspace('homepage');
                        reject();
                    }
                    resolve();
                });
            }],
        "onExit": function () {
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@hmodules/lms/LMS.module");
                }
            },
        ]
    },
    {
        "url": '/employer-dashboard',
        "name": "lms.lms-employer-dashboard",
        "loginRequired": true,
        "type": "frontend",
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-employer-dashboard/lms-employer-dashboard.html",
                controller: "LMSEmployerDashboardController",
                controllerAs: "$ctrl",
            }
        },
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Learners Dashboard | Harri"
            }
        ]
    },
    {
        "url": '/elearning',
        "name": "elearning-northpass",
        "loginRequired": true,
        "type": "frontend",
        templateUrl: "../hmodules/lms/controllers/lms-elearning/lms-elearning.html",
        controller: "LMSElearningController",
        controllerAs: "$ctrl",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Northpass"
            }
        ],
        "abstract": true,
        "onEnter": ['userServices', '$state', '$filter', 'hUser', '$timeout', 'brandServices', function (userServices, $state, $filter, hUser, $timeout, brandServices) {
                // onEnter for children routes will wait until parent route return the promise
                // for more info https://ui-router.github.io/guide/transitionhooks#promises
                return new Promise(async (resolve, reject) => {
                    let isHarriAcademyEnabled = false;
                    if (hUser.isEmployer()) {
                        let brandId = hUser.getUserContext().brand_id;
                        isHarriAcademyEnabled = await brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, brandId);
                    }
                    if (!isHarriAcademyEnabled) {
                        Utils.hAlert({
                            title: $filter('translate')("Something Went Wrong"),
                            text: $filter('translate')("You don't have sufficient permissions to access Harri E Learning. Please contact us for more details."),
                            custom_class: 'rejection-templates-error-alert',
                            button: {
                                text: $filter('translate')("Okay")
                            }
                        });
                        Utils.redirectToWorkspace('homepage');
                        reject();
                    }
                    resolve();
                });
            }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@hmodules/lms/LMS.module");
                }
            },
        ]
    },
    {
        "url": "/employer-dashboard/learners",
        "name": "lms.lms-employer-dashboard-learners",
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-employer-dashboard-learners-grid/lms-employer-dashboard-learners-grid.html",
                controller: "LMSEmployerDashboardLearnersGridController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Dashboard | Harri"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/people-platform/people-platform.downgrade.module");
                }
            },
        ]
    },
    {
        "url": '/employer-dashboard/learner?{learner_id:[0-9]+}',
        "name": "lms.lms-employer-dashboard-view-learners",
        "reloadOnSearch": false,
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-employer-dashboard-learner-view/lms-employer-dashboard-learner-view.html",
                controller: "LMSEmployerDashboardLearnerViewController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Learner View | Harri"
            }
        ]
    },
    {
        "url": '/courses',
        "name": "lms.lms-courses",
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-courses/lms-courses.html",
                controller: "LMSCoursesDashboardController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Courses Dashboard | Harri"
            }
        ]
    }, {
        "url": '/lms-settings',
        "name": "lms.lms-settings",
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-settings/lms-settings.html",
                controller: "LmsSettingsController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Settings | Harri"
            }
        ],
        "onEnter": ['userPermissions', 'hUser', '$state', async (userPermissions, hUser, $state) => {
                let policyParser = await userPermissions.getBrandPolicy(hUser.getEntryMode()['brand_id']);
                if (policyParser.has(userPermissions.LMS['MANAGE_AUTO_ENROLLMENT_SETTINGS'])) {
                    $state.go("lms.lms-settings");
                }
                else {
                    $state.go("lms.lms-employer-dashboard");
                }
            }],
    },
    {
        "url": '/lms-reporting',
        "name": "lms.lms-reporting",
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-reporting/lms-reporting.html",
                controller: "LMSReportingController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Reporting | Harri"
            }
        ]
    },
    {
        "url": '/course/:course_id',
        "name": "lms.lms-course",
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            "framework": "bootstrap_v4"
        },
        "views": {
            "body": {
                templateUrl: "../hmodules/lms/controllers/lms-course-management/lms-course-management.html",
                controller: "LMSCourseManagementController",
                controllerAs: "$ctrl",
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "LMS Course | Harri"
            }
        ]
    }
];
//# sourceMappingURL=LMS.routes.js.map